import { AppReducerBase, LOGIN_TYPE, RouteGf, RoutesGf, WebContainer } from 'gf-ui'
import "gf-ui/build/assets/scss/App.scss"
import React, { useMemo } from 'react'
import "./App.scss"
import { Home, PAGINE, TIPOLOGIE } from './pages'
import 'animate.css';


const App = () => {
    const reducer = new AppReducerBase();    

    /**
   * Definisce le routes dell'applicativo
   * @returns
   */
    const routes = useMemo(() => {
        const routes = new RoutesGf()
        routes.addRoute(new RouteGf("/", "home", <Home />))
        Object.keys(TIPOLOGIE).forEach( t => {
            const tipologia = TIPOLOGIE[t]            
            Object.keys(PAGINE).forEach( p => {
                const pagina = PAGINE[p]                               
                const paginaUrl = typeof pagina.URL === "function" ? pagina.URL(tipologia) : pagina.URL
                routes.addRoute(new RouteGf(`/${tipologia.URL}${paginaUrl}`, `${pagina.NAME}${tipologia.NAME}`, pagina.COMPONENT(tipologia)))
            })
        })                        
        return routes;
    }, [])

    return (
        <WebContainer
            loginType={LOGIN_TYPE.NO}
            reducer={reducer}
            moduloRoutes={routes}            
            showHeader={false}
        />            
    )
}
export default App;
